/**
 * Swap an opted-in form's nonce fields for live ones before it's submitted.
 *
 * The page may come from a 24h cache while its nonces expire after 12-24h; see
 * inc/forms/fresh-nonces.php. Fetches when a visitor first starts on the form
 * (focus, tap or keypress - Safari doesn't focus radios and selects on click),
 * and again if the tab has been open longer than MAX_AGE.
 */
(function () {
  'use strict';

  var MAX_AGE = 60 * 60 * 1000;
  var settings = window.pcmFreshNonces || {};

  function refresh(form) {
    var fetchedAt = Number(form.dataset.pcmNoncesFetchedAt || 0);

    if (!settings.ajaxUrl || Date.now() - fetchedAt < MAX_AGE) {
      return;
    }

    var fields = (form.getAttribute('data-pcm-fresh-nonces') || '').split(/\s+/).filter(Boolean);

    if (!fields.length) {
      return;
    }

    form.dataset.pcmNoncesFetchedAt = String(Date.now());

    var body = new FormData();
    body.append('action', 'pcm_fresh_form_nonces');
    fields.forEach(function (field) {
      body.append('fields[]', field);
    });

    fetch(settings.ajaxUrl, { method: 'POST', body: body, credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (result) {
        if (!result || !result.success) {
          throw new Error('nonce refresh failed');
        }

        Object.keys(result.data).forEach(function (field) {
          var inputs = form.querySelectorAll('input[name="' + field + '"]');

          Array.prototype.forEach.call(inputs, function (input) {
            input.value = result.data[field];
          });
        });
      })
      .catch(function () {
        // Let the next interaction try again.
        form.dataset.pcmNoncesFetchedAt = '0';
      });
  }

  function onInteract(event) {
    var form = event.target && event.target.closest ? event.target.closest('form[data-pcm-fresh-nonces]') : null;

    if (form) {
      refresh(form);
    }
  }

  document.addEventListener('focusin', onInteract);
  document.addEventListener('pointerdown', onInteract);
  document.addEventListener('keydown', onInteract);
})();
